<template>
  <HeaderApp />
  <div class="mt-14"></div>

  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 ' +
      (isHide == true
        ? '  '
        : $store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
    id="printDev"
  >
    <InvoiceHeader invoice_type="items_list" v-if="isHide == true" />

    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <div class="flex items-center justify-between">
        <div>
          <h1 class="text-2xl font-bold text-gray-900 dark:text-white">
            {{ $t("items_list") }}
          </h1>
        </div>
      </div>
    </div>

    <!-- Stats Cards -->
    <div class="px-6 py-4">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <!-- Total Cost Card -->

        <ReportComponent
          :labelDolar="formatNumber(total['sumCostAllDolar'])"
          :labelDinar="formatNumber(total['sumCostAllDinar'])"
          :labelTitle="$t('total_cost')"
          :classColor="isDark ? 'from-red-500' : 'from-red-50 to-red-100'"
        />

        <ReportComponent
          :labelDolar="formatNumber(total['sumSaleAllDolar'])"
          :labelDinar="formatNumber(total['sumSaleAllDinar'])"
          :labelTitle="$t('total_sale')"
          :classColor="isDark ? 'from-blue-500' : 'from-blue-50 to-blue-100'"
        />
      </div>
    </div>
    <!-- Filters and Controls -->
    <div
      class="px-6 py-4 border-b border-gray-200 dark:border-gray-700"
      v-if="isHide != true"
    >
      <div
        class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4"
      >
        <!-- Search and Print Actions -->
        <div class="flex items-center space-x-4">
          <div class="relative">
            <div
              class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
            >
              <i
                class="fa-solid fa-search text-gray-400 dark:text-gray-500"
              ></i>
            </div>
            <input
              type="text"
              id="table-search"
              class="block w-full pl-10 pr-3 py-2 text-sm bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
              :placeholder="$t('search_items')"
              @input="
                $store.commit('item_list/SET_SEARCH', $event.target.value),
                  loadFromServer(),
                  (serverOptions.page = 1)
              "
            />
          </div>
          <div class="w-2"></div>
          <button
            class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 no-print"
            @click="printReportFunc"
            id="button_print"
            v-if="$store.getters['checkPrintAccess']"
          >
            <i class="fa-solid fa-print mr-2"></i>
            {{ $t("print") }}
          </button>
        </div>

        <!-- Column Selection -->
        <div class="flex items-center space-x-4">
          <CustomMultiSelect
            v-model="selectedHeaders"
            :options="headers"
            track-by="value"
            label="text"
            :placeholder="$t('columns')"
            :header-text="$t('which_columns_to_display')"
            @update:modelValue="printCall"
          />
          <div class="w-2"></div>
          <button
            @click="resetToDefaultHeaders"
            class="inline-flex items-center px-3 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg border border-gray-300 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors duration-200 text-sm font-medium"
            :title="$t('reset_to_default')"
          >
            <i class="fa fa-refresh mr-2"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Table Container -->
    <div class="px-6 py-4">
      <div
        class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
      >
        <EasyDataTable
          :key="`table-${isDark ? 'dark' : 'light'}`"
          v-model:server-options="serverOptions"
          :headers="showHeaders"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100, serverItemsLength]"
          rows-per-page="10"
          :table-class-name="isDark ? 'modern-dark-table' : ''"
        >
          <template #default="{ column, sortDirection }">
            <div
              :class="`flex items-center space-x-2 ${
                $store.getters['isRtl'] ? 'justify-end' : 'justify-start'
              }`"
            >
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{
                column.label
              }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
              </span>
            </div>
          </template>
          <template #item-i_show="item">
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
              v-if="item.i_show == 1"
            >
              <i class="fa-solid fa-eye mr-1"></i>
              <div class="w-1"></div>
              {{ $t("show") }}
            </span>
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
              v-else-if="item.i_show == 0"
            >
              <i class="fa-solid fa-eye-slash mr-1"></i>
              <div class="w-1"></div>
              {{ $t("hide") }}
            </span>
          </template>
          <template #item-i_state="item">
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
              v-if="item.i_state == 1"
            >
              <i class="fa-solid fa-check-circle mr-1"></i>
              <div class="w-1"></div>
              {{ $t("active") }}
            </span>
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
              v-else-if="item.i_state == 0"
            >
              <i class="fa-solid fa-times-circle mr-1"></i>
              <div class="w-1"></div>
              {{ $t("deactive") }}
            </span>
          </template>
          <template #item-i_link="item">
            <a
              :href="item.i_link"
              target="_blank"
              v-if="item.i_link"
              class="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-600 bg-blue-100 rounded-md hover:bg-blue-200 transition-colors duration-200"
            >
              <i class="fa-solid fa-external-link-alt mr-1"></i>
              Link
            </a>
            <span v-else class="text-gray-400 text-sm">—</span>
          </template>
          <template #item-actions="item">
            <div class="flex items-center justify-center space-x-2">
              <button
                @click="showModal(item)"
                v-if="
                  $store.getters['checkUserAccess']({ id: '8', action: 'edit' })
                "
                class="inline-flex items-center p-2 text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
                :title="$t('edit')"
              >
                <i class="fa-solid fa-pen text-sm"></i>
              </button>
              <button
                @click="deleteItem(item.i_id)"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '8',
                    action: 'delete',
                  })
                "
                class="inline-flex items-center p-2 text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors duration-200"
                :title="$t('delete')"
              >
                <i class="fa-solid fa-trash text-sm"></i>
              </button>
              <a
                :href="'item-detail/' + item.i_id"
                target="_blank"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '8',
                    action: 'detail',
                  })
                "
                class="inline-flex items-center p-2 text-green-600 bg-green-50 hover:bg-green-100 rounded-lg transition-colors duration-200"
                :title="$t('view_details')"
              >
                <i class="fa-solid fa-eye text-sm"></i>
              </a>
            </div>
          </template>
          <template #item-i_image="item">
            <div class="flex justify-center">
              <img
                :src="file_url + item.i_image"
                class="h-12 w-12 rounded-lg object-cover border border-gray-200 dark:border-gray-600 cursor-pointer hover:opacity-80 transition-opacity duration-200"
                alt="Item image"
                v-if="item.i_image"
                @click="openModal(file_url + item.i_image)"
              />
              <div
                v-else
                class="h-12 w-12 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center border border-gray-200 dark:border-gray-600"
              >
                <i class="fa-solid fa-image text-gray-400"></i>
              </div>
            </div>
          </template>
          <template #item-suplier_su_name="item">
            <span
              v-if="item.suplier == null || item.suplier == ''"
              class="text-gray-400 text-sm"
            >
              —
            </span>
            <span v-else class="text-gray-900 dark:text-gray-100 font-medium">
              {{ item.suplier.su_name }}
            </span>
          </template>
          <template #item-currency_cur_name="item">
            <span
              class="inline-flex items-center px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200 rounded-md"
            >
              {{ $t(item.currency.cur_name) }}
            </span>
          </template>
          <template #item-i_sale_price="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.i_sale_price) }}
              </span>
              <span class="text-xs text-gray-500 dark:text-gray-400 ml-1">
                {{ $t(item.currency.cur_name) }}
              </span>
            </div>
          </template>
          <template #item-i_sale_price_jwmla="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.i_sale_price_jwmla) }}
              </span>
              <span class="text-xs text-gray-500 dark:text-gray-400 ml-1">
                {{ $t(item.currency.cur_name) }}
              </span>
            </div>
          </template>
          <template #item-i_discount="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.i_discount) }}
              </span>
              <span class="text-xs text-gray-500 dark:text-gray-400 ml-1">
                {{ $t(item.currency.cur_name) }}
              </span>
            </div>
          </template>
          <template #item-i_desc="item">
            <span
              v-if="item.i_desc == null || item.i_desc == ''"
              class="text-gray-400 text-sm"
            >
              —
            </span>
            <span
              v-else
              class="text-gray-900 dark:text-gray-100 max-w-xs truncate"
              :title="item.i_desc"
            >
              {{ item.i_desc }}
            </span>
          </template>
          <template #item-i_expire_date="item">
            <span
              v-if="item.i_expire_date == null || item.i_expire_date == ''"
              class="text-gray-400 text-sm"
            >
              —
            </span>
            <span v-else class="text-gray-900 dark:text-gray-100">
              {{ item.i_expire_date }}
            </span>
          </template>
          <template #loading>
            <div class="flex justify-center items-center py-8">
              <div
                class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
              ></div>
              <span class="ml-3 text-gray-600 dark:text-gray-400"
                >{{ $t("loading") }}...</span
              >
            </div>
          </template>
          <template #item-created_at="item">
            <span class="text-gray-600 dark:text-gray-400 text-sm">
              {{ formatDate(item.created_at) }}
            </span>
          </template>
          <template #item-i_packages="item">
            <div v-if="item.i_packages && item.i_packages.length > 0" class="space-y-1">
              <div
                v-for="(pkg, index) in item.i_packages"
                :key="index"
                class="text-xs bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-2 py-1 rounded"
              >
                {{ pkg.name }}: {{ pkg.quantity }}+ = {{ formatNumber(pkg.price) }}
              </div>
            </div>
            <span v-else class="text-gray-400 text-sm">
              {{ $t("no_packages") }}
            </span>
          </template>
          <template #empty-message>
            <div class="text-center py-12">
              <i class="fa-solid fa-box-open text-4xl text-gray-400 mb-4"></i>
              <p class="text-gray-500 dark:text-gray-400 text-lg font-medium">
                {{ $t("no_data_found") }}
              </p>
              <p class="text-gray-400 dark:text-gray-500 text-sm mt-2">
                {{ $t("try_adjusting_your_search_criteria") }}
              </p>
            </div>
          </template>

          <template
            #pagination="{
              prevPage,
              nextPage,
              isFirstPage,
              isLastPage,
              currentPaginationNumber,
              maxPaginationNumber,
            }"
          >
            <button :disabled="isFirstPage" @click="goToPage(1)">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-right'
                    : ' fa-angle-double-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-chevron-right'
                    : ' fa-chevron-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              v-for="page in getVisiblePages(
                currentPaginationNumber,
                maxPaginationNumber
              )"
              :key="page"
              @click="goToPage(page)"
              :class="getPageButtonClasses(page, currentPaginationNumber)"
            >
              {{ page }}
            </button>

            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              :disabled="isLastPage"
              @click="goToPage(maxPaginationNumber)"
            >
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-left'
                    : ' fa-angle-double-right')
                "
              ></i>
            </button>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <BaseInput
          v-model="current.i_barcode"
          :label="$t('item_barcode')"
          :placeholder="$t('item_barcode')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.i_barcode, 'add', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.i_barcode, 'add', this.no_rule).errorMsg
          "
        />
        <BaseInput
          v-model="current.i_name"
          :label="$t('item_name')"
          :placeholder="$t('item_name')"
          :rules="rules"
          :isError="
            checkRulesIsError(current.i_name, 'add', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.i_name, 'add', this.rules).errorMsg
          "
        />

        <DropdownInput
          v-model="current.i_show"
          :label="$t('show_hide_item')"
          :items="[
            { id: 1, value: $t('show') },
            { id: 0, value: $t('hide') },
          ]"
          :placeholder="$t('show_hide_item')"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(current.i_show, 'add', this.rules_dropdown)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.i_show, 'add', this.rules_dropdown)
              .errorMsg
          "
        />
        <DropdownInput
          v-model="current.i_state"
          :label="$t('status')"
          :items="[
            { id: 1, value: $t('active') },
            { id: 0, value: $t('deactive') },
          ]"
          :placeholder="$t('status')"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(current.i_state, 'add', this.rules_dropdown)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.i_state, 'add', this.rules_dropdown)
              .errorMsg
          "
        />
        <BaseInput
          v-model="current.i_link"
          :label="$t('item_link')"
          :placeholder="$t('item_link')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.i_link, 'add', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.i_link, 'add', this.no_rule).errorMsg
          "
        />
        <DropdownInput
          v-model="current.ca_id"
          :placeholder="$t('choose_item_category')"
          :label="$t('item_category')"
          :items="convertToListIdValueCategory"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(current.ca_id, 'add', this.rules_dropdown).isError
          "
          :errorMsg="
            checkRulesIsError(current.ca_id, 'add', this.rules_dropdown)
              .errorMsg
          "
        /><DropdownInput
          v-model="current.un_id"
          :label="$t('item_unit')"
          :items="convertToListIdValueUnits"
          :placeholder="$t('choose_item_unit')"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(current.un_id, 'add', this.rules_dropdown).isError
          "
          :errorMsg="
            checkRulesIsError(current.un_id, 'add', this.rules_dropdown)
              .errorMsg
          "
        />
        <!-- 
        <div>
          <label
            for="saleType"
            class="block mb-2 text-base font-medium text-textBlack1 dark:text-textWhite1"
            >{{ $t("suplier") }}</label
          >
          <VueMultiselect
            v-model="current.su_id"
            :options="convertToListIdValueSupliers"
            :multiple="false"
            :placeholder="$t('choose_suplier')"
            label="value"
            track-by="id"
            :taggable="true"
          >
          </VueMultiselect>
        </div>-->
        <DropdownInput
          v-model="current.cur_id"
          :label="$t('currency_type')"
          :items="convertToListIdValue"
          :placeholder="$t('choose_currency_type')"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(current.cur_id, 'add', this.rules_dropdown)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.cur_id, 'add', this.rules_dropdown)
              .errorMsg
          "
        />
        <BaseInput
          v-model="current.i_sale_price"
          :label="$t('sale_item_price')"
          :placeholder="$t('sale_item_price')"
          :rules="rules"
          type="number"
          :isError="
            checkRulesIsError(current.i_sale_price, 'add', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.i_sale_price, 'add', this.rules).errorMsg
          "
        />
        <BaseInput
          v-model="current.i_sale_price_jwmla"
          :label="$t('sale_jwmla_price')"
          :placeholder="$t('sale_jwmla_price')"
          :rules="rules"
          type="number"
          :isError="
            checkRulesIsError(current.i_sale_price_jwmla, 'add', this.rules)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.i_sale_price_jwmla, 'add', this.rules)
              .errorMsg
          "
        />

        <BaseInput
          v-model="current.i_discount"
          :label="$t('discount')"
          :placeholder="$t('discount')"
          :rules="rules"
          type="number"
          :isError="
            checkRulesIsError(current.i_discount, 'add', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.i_discount, 'add', this.rules).errorMsg
          "
        />

        <BaseInput
          v-model="current.i_main_currency_price"
          :label="$t('dolar_price_in_bought_item_date')"
          :placeholder="$t('dolar_price_in_bought_item_date')"
          :rules="rules"
          type="number"
          :isError="
            checkRulesIsError(current.i_main_currency_price, 'add', this.rules)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.i_main_currency_price, 'add', this.rules)
              .errorMsg
          "
        />
        <BaseInput
          v-model="current.i_expire_date"
          type="date"
          :label="$t('expire_Date')"
          :placeholder="$t('write_expire_date_if_has')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.i_expire_date, 'add', this.no_rule)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.i_expire_date, 'add', this.no_rule)
              .errorMsg
          "
        />

        <div>
          <label
            for="image"
            class="block mb-2 text-base font-medium text-textBlack1 dark:text-textWhite1"
          >
            {{ $t("item_photo") }}</label
          >
          <label
            for="image"
            class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 remove-arrow"
          >
            <i class="fa fa-cloud-upload mx-1"></i>

            {{
              i_image == ""
                ? $t("choose_item_photo_if_you_want_change")
                : i_image.name
            }}
          </label>
          <input
            type="file"
            v-on:change="onChange"
            :placeholder="$t('choose_item_photo_if_you_want_change')"
            id="image"
            class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 remove-arrow"
          />
        </div>

        <TextAreaInput
          v-model="current.i_desc"
          :label="$t('item_description')"
          :placeholder="$t('item_description')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.i_desc, 'add', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.i_desc, 'add', this.no_rule).errorMsg
          "
        />

        <!-- Package Pricing Section -->
        <div class="mb-6">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            {{ $t("package_pricing") }}
          </h3>
          <div class="space-y-4">
            <div
              v-for="(pkg, index) in current.i_packages"
              :key="index"
              class="flex items-center space-x-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
            >
              <div class="flex-1">
                <BaseInput
                  v-model="pkg.name"
                  :label="$t('package_name')"
                  :placeholder="$t('package_name')"
                  :rules="no_rule"
                />
              </div>
              <div class="flex-1">
                <BaseInput
                  v-model="pkg.quantity"
                  type="number"
                  :label="$t('package_quantity')"
                  :placeholder="$t('package_quantity')"
                  :rules="no_rule"
                />
              </div>
              <div class="flex-1">
                <BaseInput
                  v-model="pkg.price"
                  type="number"
                  :label="$t('package_price')"
                  :placeholder="$t('package_price')"
                  :rules="no_rule"
                />
              </div>
              <button
                type="button"
                @click="removePackage(index)"
                class="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors duration-200"
              >
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
            <button
              type="button"
              @click="addPackage"
              class="w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200"
            >
              <i class="fa-solid fa-plus mr-2"></i>
              {{ $t("add_package") }}
            </button>
          </div>
        </div>
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div> </edit-modal
  ><image-modal ref="imageModal" />
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import { formatNumber } from "../../utils/functions";
import { FILE_URL } from "../../constants/config";
import { CURRENCYS } from "../../constants/config";
import ImageModal from "../../components/Modals/ImageModal2.vue";

// Import modern table styles
import "../../assets/css/modern-table.css";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import CustomMultiSelect from "../../components/Inputs/CustomMultiSelect.vue";
import ReportComponent from "../../components/Report/ReportComponent.vue";

export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    CustomMultiSelect,
    ConfirmDialogue,
    ReportComponent,
    ResultDialog,
    EditModal,
    DropdownInput,
    TextAreaInput,
    ImageModal,
    InvoiceHeader,
  },
  data() {
    return {
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      no_rule: [],
      firstName: "",
      rules: [
        (value) => {
          if (value || value == 0) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      currencys: CURRENCYS,
      ic_name: "",
      inputType: "text",
      placeholderText: "ناوی جۆری داهات",
      isSubmited: false,
      isSubmitedEdit: false,
      i_image: "",
      current: {},
      file_url: FILE_URL,
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      items: [],
      total: {},
      isHide: false,
      selectedHeaders: [],
      columnsControl: false,
    };
  },
  mounted() {
    // First load when the component is mounted
    this.loadFromServer();
    this.loadSelectedHeaders();
  },
  created() {
    this.$store.dispatch("item_category/getCategory");

    this.$store.dispatch("item_unit/getUnits");
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.item_list.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.item_list.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("item_list/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
    headers: {
      handler() {
        // When headers change, update selectedHeaders to match
        if (this.headers && this.headers.length > 0) {
          this.loadSelectedHeaders();
        }
      },
      immediate: true,
    },
    isDark: {
      handler() {
        // Force table re-render when theme changes
        this.$nextTick(() => {
          // Trigger a small delay to ensure theme change is applied
          setTimeout(() => {
            this.loadFromServer();
          }, 100);
        });
      },
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.item_list.isShowResultDialog;
    },

    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.item_list.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.item_list.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.item_list.isBtnEditLoading;
    },
    headers() {
      var listHeader = [
        {
          text: this.$t("actions"),
          value: "actions",
          sortable: false,
          hidden: true,
        },
        { text: this.$t("item_barcode"), value: "i_barcode", sortable: true },
        { text: this.$t("item_name"), value: "i_name", sortable: true },
        {
          text: this.$t("photo"),
          value: "i_image",
          sortable: true,
        },
        {
          text: this.$t("item_category"),
          value: "category.ca_name",
          sortable: true,
        },
        {
          text: this.$t("last_suplier"),
          value: "suplier_su_name",
          sortable: true,
        },
        {
          text: this.$t("unit"),
          value: "unit.un_name",
          sortable: true,
        },

        {
          text: this.$t("avg_cost"),
          value: "i_cost_price",
          sortable: true,
        },
        {
          text: this.$t("sale_item_price"),
          value: "i_sale_price",
          sortable: true,
        },
        {
          text: this.$t("sale_jwmla_price"),
          value: "i_sale_price_jwmla",
          sortable: true,
        },
        {
          text: this.$t("discount"),
          value: "i_discount",
          sortable: true,
        },

        {
          text: this.$t("item_quantity_in_storage"),
          value: "i_quantity",
          sortable: true,
        },
        {
          text: this.$t("item_bought_quantity_till_now"),
          value: "i_in_quantity",
          sortable: true,
        },
        {
          text: this.$t("item_sold_quantity_till_now"),
          value: "i_out_quantity",
          sortable: true,
        },

        {
          text: this.$t("dolar_price"),
          value: "i_main_currency_price",
          sortable: true,
        },
        {
          text: this.$t("show"),
          value: "i_show",
          sortable: true,
        },
        {
          text: this.$t("status"),
          value: "i_state",
          sortable: true,
        },
        //i_link
        {
          text: this.$t("item_link"),
          value: "i_link",
          sortable: true,
        },

        {
          text: this.$t("item_expire_date"),
          value: "i_expire_date",
          sortable: true,
        },
        { text: this.$t("note"), value: "i_desc", sortable: true },
        {
          text: this.$t("packages"),
          value: "i_packages",
          sortable: false,
        },
        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
      ];

      return listHeader;
    },
    showHeaders() {
      var temp = [];
      //cretae a for check all selectedHeaders add to temp
      for (let i = 0; i < this.selectedHeaders.length; i++) {
        for (let j = 0; j < this.headers.length; j++) {
          if (this.selectedHeaders[i].text == this.headers[j].text) {
            temp.push(this.headers[j]);
          }
        }
      }

      if (temp.length == 0) {
        temp = this.headers;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.selectedHeaders = temp;
      }

      return temp;
    },
    convertToListIdValue() {
      var list = [];
      for (const item of this.currencys) {
        list.push({
          id: item.cur_id,
          value: this.$t(item.cur_name),
        });
      }

      return list;
    },
    convertToListIdValueUnits() {
      var boxes = this.$store.state.item_unit.units;
      var list = [];
      for (const item of boxes) {
        list.push({
          id: item.un_id,
          value: item.un_name,
        });
      }

      return list;
    },

    convertToListIdValueCategory() {
      var categorys = this.$store.state.item_category.categorys;
      var list = [];
      for (const item of categorys) {
        list.push({
          id: item.ca_id,
          value: item.ca_name,
        });
      }

      return list;
    },
  },

  methods: {
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content and wait after it refresh page
        window.print();
        //wait 5 seconds
        // Adjust the timeout as needed
        //reload page
      }, 100);
      //print element id invoice_print
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3; // Adjust this number based on your design preference
      const pages = [];

      // Display pages 1 to numVisibleButtons (e.g., 1, 2, 3)
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      }
      // Display pages around the current page (e.g., 1, ..., 10, ..., 20)
      else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }

      return pages;
    },

    // Function to get Tailwind CSS classes for each page button
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true, // Adjust padding and rounding based on your design
      };
    },

    goToPage(page) {
      // Implement your logic to update the current page
      //update page
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    async loadFromServer() {
      this.loading = true;

      var tempObj = { ...this.serverOptions };
      //add new field to object search
      tempObj.search = this.$store.state.item_list.search;

      const res = await this.$store.dispatch("item_list/getItems", tempObj);

      this.items = res.data.items.data;
      this.total = res.data.total;
      this.serverItemsLength = res.data.items.total;
      this.loading = false;
    },
    openModal(image) {
      this.$refs.imageModal.show(image);
    },
    formatNumber(number) {
      return formatNumber(number);
    },
    formatDate(date) {
      return formatDate(date);
    },
    getData() {
      this.$store.dispatch("item_list/getItems");
    },

    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";

      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("item_list/REMOVE_ITEM", id);
        await this.$store.dispatch("item_list/deleteItem", id);
        this.loadFromServer();
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      if (this.current.su_id != null) {
        this.current.su_id = {
          id: item.su_id,
          value: item.suplier.su_name,
        };
      } else {
        this.current.su_id = {
          id: null,
          value: null,
        };
      }
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.i_name, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.i_sale_price, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(
          this.current.i_sale_price_jwmla,
          "edit",
          this.rules
        ).isError ||
        this.checkRulesIsError(this.current.i_show, "edit", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.current.i_barcode, "edit", this.no_rule)
          .isError ||
        this.checkRulesIsError(
          this.current.i_state,
          "edit",
          this.rules_dropdown
        ).isError
      ) {
        return;
      }
      this.$store.state.item_list.isBtnEditLoading = true;
      
      // Handle packages: ensure we send packages even if empty
      let packages = this.current.i_packages;
      if (!packages || !Array.isArray(packages)) {
        packages = []; // Ensure it's always an array
      }
      
      // Validate packages: each package must have a name
      if (packages.length > 0) {
        for (let i = 0; i < packages.length; i++) {
          if (!packages[i].name || packages[i].name.trim() === '') {
            this.$store.state.item_list.isBtnEditLoading = false;
            alert(this.$t('package_name_required') || 'Package name is required for all packages');
            return;
          }
        }
      }
      
      // Debug log
      console.log('Sending packages:', packages, 'Length:', packages.length);
      
      var res = await this.$store.dispatch("item_list/editItem", {
        i_name: this.current.i_name,
        i_id: this.current.i_id,
        i_barcode: this.current.i_barcode,
        i_show: this.current.i_show,
        i_state: this.current.i_state,
        i_link: this.current.i_link,
        ca_id: this.current.ca_id,
        //   su_id: this.current.su_id.id,
        un_id: this.current.un_id,
        cur_id: this.current.cur_id,

        i_sale_price: this.current.i_sale_price,
        i_sale_price_jwmla: this.current.i_sale_price_jwmla,
        i_discount: this.current.i_discount,

        i_main_currency_price: this.current.i_main_currency_price,
        i_expire_date: this.current.i_expire_date,
        i_image: this.i_image,
        i_desc: this.current.i_desc,
        i_packages: JSON.stringify(packages), // Send as JSON string for multipart
      });

      this.isSubmitedEdit = false;
      this.$store.state.item_list.isBtnEditLoading = false;
      if (res.status == 200) {
        this.i_image = "";
        this.$refs.editModal.hide();
        this.loadFromServer();
      }
    },
    onChange(e) {
      this.i_image = e.target.files[0];
      e.target.value = "";
    },
    loadSelectedHeaders() {
      // Load selected headers from localStorage
      const savedHeaders = localStorage.getItem("itemListSelectedHeaders");
      if (savedHeaders) {
        try {
          const parsedHeaders = JSON.parse(savedHeaders);
          // Filter to only include headers that exist in current headers list
          this.selectedHeaders = this.headers.filter((header) =>
            parsedHeaders.some((saved) => saved.value === header.value)
          );
        } catch (error) {
          console.error("Error loading saved headers:", error);
          this.selectedHeaders = [...this.headers];
        }
      } else {
        // If no saved headers, select all by default
        this.selectedHeaders = [...this.headers];
      }
    },
    saveSelectedHeaders() {
      // Save selected headers to localStorage
      try {
        localStorage.setItem(
          "itemListSelectedHeaders",
          JSON.stringify(this.selectedHeaders)
        );
      } catch (error) {
        console.error("Error saving headers:", error);
      }
    },
    printCall(selectedHeaders) {
      // Handle column selection changes
      if (selectedHeaders && Array.isArray(selectedHeaders)) {
        this.selectedHeaders = selectedHeaders;
        this.saveSelectedHeaders();
      }
    },
    resetToDefaultHeaders() {
      // Reset to select all headers
      this.selectedHeaders = [...this.headers];
      this.saveSelectedHeaders();
    },
    getTableClass() {
      return this.isDark ? "modern-dark-table" : "modern-light-table";
    },
    getTableClassName() {
      return this.isDark
        ? "modern-table dark-table"
        : "modern-table light-table";
    },
    addPackage() {
      if (!this.current.i_packages) {
        this.current.i_packages = [];
      }
      this.current.i_packages.push({
        name: "",
        quantity: 1,
        price: 0,
      });
    },
    removePackage(index) {
      if (this.current.i_packages) {
        this.current.i_packages.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
/* Custom styles specific to ItemList page */
</style>
<style scoped>
input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(40%) sepia(96%) saturate(694%) hue-rotate(195deg)
    brightness(85%) contrast(88%);
}

input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
} /* Add your gallery styles here */
.gallery {
  cursor: pointer;
  margin: 5px;
}

.gallery img {
  width: 100px;
  height: auto;
}
</style>
